<div class="kt-side_more">
	<div class="kt-side_more__title">
		<span> {{ "HOME.HIGHLIGHTS" | translate }}</span>
		<span class="side_more_right_arrow">
			<i class="fa fa-arrow-right text-white"></i>
		</span>
	</div>
	<div class="kt-side_more__title">
		<span> {{ "HOME.STARTER_INDEX" | translate }}</span>
		<span class="side_more_right_arrow">
			<i class="fa fa-arrow-right text-white"></i>
		</span>
	</div>
	<div class="kt-side_more__title">
		<span>{{ "RACES.BET_TYPES" | translate }}</span>
		<span class="side_more_right_arrow">
			<i class="fa fa-arrow-right text-white"></i>
		</span>
	</div>
</div>
